import { render } from "./searchProduct.vue?vue&type=template&id=77481f5e"
import script from "./searchProduct.vue?vue&type=script&lang=js"
export * from "./searchProduct.vue?vue&type=script&lang=js"

import "./searchProduct.vue?vue&type=style&index=0&id=77481f5e&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__